<script setup lang="ts">
definePageMeta({
  layout: "marketing",
  title: "Artikler",
})
</script>

<template>
  <UMarketingArticle />
</template>
